<template>
  <div class="content">
    <el-tabs v-model="tabName">
      <el-tab-pane label="普通用户" name="first">
        <div class="filter">
          <el-input placeholder="请输入内容" v-model="filterValue" class="filter-input" clearable @blur="resetPage" @clear="clear">
            <el-select v-model="filterType" slot="prepend" placeholder="请选择" style="width:140px">
              <el-option label="邮箱/手机号" :value="3"/>
              <el-option label="用户名" :value="1"/>
              <el-option label="用户ID" :value="2"/>
            </el-select>
          </el-input>

          <!-- <el-select v-model="listParams.isAuthentication" placeholder="是否认证" clearable @change="resetPage">
            <el-option label="已认证" value="1"></el-option>
            <el-option label="未认证" value="0"></el-option>
          </el-select> -->
          <el-select v-model="listParams.userGroup" placeholder="用户分组" clearable @change="resetPage">
            <el-option v-for="item in group" :label="item.name" :key="item.code" :value="item.code"></el-option>
          </el-select>
          <el-date-picker v-model="registerDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleTimeChange">
          </el-date-picker>
          <el-button @click="exportData" style="margin-left:10px">导出数据</el-button>
        </div>

        <el-table :data="userList" height="calc(100vh - 240px)" @sort-change="userRegisterTimeSort">
          <el-table-column prop="userId" label="ID"></el-table-column>
          <el-table-column prop="fullName" label="用户名"></el-table-column>
          <el-table-column label="邮箱/手机号">
            <template slot-scope="{row}">
              <div>{{ row.showName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userGroup" label="用户分组">
            <template slot-scope="{row}">
              <el-select v-model="row.userGroup" @change="value=>changeGroup(value,row)">
                <el-option v-for="item in group" :label="item.name" :key="item.code" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="isAuthentication" label="是否认证" width="100"></el-table-column>
          <el-table-column prop="referrer" label="来源"></el-table-column>
          <el-table-column prop="registerDate" label="注册时间" sortable="custom"></el-table-column>
          <el-table-column prop="date" label="对接人">
            <template slot-scope="scope">
              <el-select v-model="scope.row.userManager" placeholder="对接人" @change="e => managerChange(scope.row.userId, e)">
                <el-option v-for="item in managerSelectList" :key="item.userId" :label="item.fullName" :value="item.userId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="$store.getters.userRole == 4" label="登录前台" width="100">
            <template slot-scope="{row}">
              <el-button type="text" @click="jumpLogin(row)">登录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="f-b-c bg-white" style="padding: 12px">
          <div></div>
          <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
        </div>
      </el-tab-pane>

      <el-tab-pane label="管理员" name="second" :disabled="!isSuperAdministrator">
        <div class="filter f-b-c">
          <el-input placeholder="请输入内容" v-model="managerFilterValue" class="filter-input" clearable @blur="resetManagerPage" @clear="resetManagerPage">
            <el-select v-model="managerfilterType" slot="prepend" placeholder="请选择" style="width:140px">
              <el-option label="邮箱/手机号" :value="3"></el-option>
              <el-option label="用户名" :value="1"></el-option>
              <el-option label="用户ID" :value="2"></el-option>
            </el-select>
          </el-input>
          <el-button size="medium" type="primary" round @click="clickAddManager">添加管理员</el-button>
        </div>

        <el-table :data="managerList" height="calc(100vh - 240px)">
          <el-table-column prop="userId" label="ID"></el-table-column>
          <el-table-column prop="fullName" label="用户名"></el-table-column>
          <el-table-column label="邮箱/手机号">
            <template slot-scope="{row}">
              <div>{{ row.email }}</div>
              <div>{{ row.phone }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userRoleName" label="角色"></el-table-column>
          <el-table-column v-if="$store.getters.userRole == 4" label="登录前台" width="100">
            <template slot-scope="{row}">
              <el-button type="text" @click="jumpLogin(row)">登录</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="clickEditManager(scope.row)">编辑</el-button>
              <el-button type="text" @click="deletManager(scope.row.userId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="f-b-c bg-white" style="padding: 12px">
          <div></div>
          <el-pagination background :current-page="managerListParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="managerListParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="managerTotal" class="el-pagination" @size-change="managerSizeChange" @current-change="managerPageChange" />
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="新增管理员" :visible.sync="addManagerVisible" width="40%">
      <el-form :model="addManagerForm" :rules="addManagerRules" ref="addManagerForm" label-width="80px">
        <el-form-item label="用户名" prop="fullName">
          <el-input v-model="addManagerForm.fullName"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addManagerForm.email"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addManagerForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatarUrl">
          <el-upload ref="imgUrlUpload" action="#" :show-file-list="false" class="avatar-uploader" list-type="picture" :auto-upload="false" accept="image/png,image/jpg,image/jpeg" :on-change="file => uploadImage(file, false)">
            <img v-if="addManagerForm.avatarUrl" :src="addManagerForm.avatarUrl" class="avatar">
            <i v-else class="el-icon-plus uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label="角色" prop="userRole">
          <el-checkbox-group v-model="addManagerForm.userRole">
            <el-checkbox v-for="item in roleEnum" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addManager">保存</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
    <el-dialog title="修改管理员" :visible.sync="editManagerVisible" width="40%">
      <el-form :model="editManagerForm" :rules="editManagerRules" ref="editManagerForm" label-width="80px">
        <el-form-item label="用户名" prop="fullName">
          <el-input v-model="editManagerForm.fullName"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editManagerForm.email"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatarUrl">
          <el-upload ref="imgUrlUpload" action="#" :show-file-list="false" multiple class="avatar-uploader" list-type="picture" :auto-upload="false" accept="image/png,image/jpg,image/jpeg" :on-change="file => uploadImage(file, true)">
            <img v-if="editManagerForm.avatarUrl" :src="editManagerForm.avatarUrl" class="avatar">
            <i v-else class="el-icon-plus uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label="角色" prop="userRole">
          <el-checkbox-group v-model="editManagerForm.userRole">
            <el-checkbox v-for="item in roleEnum" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editManager">保存</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import roleEnum from '@/config/roleEnum'
import { dateFormat } from '@/utils/date'
import { encrypt } from '@/utils/encryp'
import { getToken } from '@/utils/auth'
export default {
  name: 'user_user',
  data() {
    const validateEmail = (rule, value, callback) => {
      if (/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱'))
      }
    }
    return {
      tabName: 'first',
      total: 0,
      managerTotal: 0,
      filterType: 3,
      managerfilterType: 3,
      filterValue: undefined,
      managerFilterValue: undefined,
      registerDate: [],
      addManagerVisible: false,
      editManagerVisible: false,
      isSuperAdministrator: false,
      listParams: {
        userRole: [1],
        fullName: undefined,
        userId: undefined,
        email: undefined,
        registerDateStart: undefined,
        registerDateEnd: undefined,
        isAuthentication: undefined,
        sortType: undefined,
        pageNumber: 1,
        pageSize: 20
      },
      managerListParams: {
        userRole: [3, 10],
        fullName: undefined,
        userId: undefined,
        email: undefined,
        pageNumber: 1,
        pageSize: 20
      },
      addManagerForm: {
        email: undefined,
        password: undefined,
        fullName: undefined,
        avatarUrl: undefined,
        userRole: []
      },
      editManagerForm: {
        userId: undefined,
        email: undefined,
        fullName: undefined,
        avatarUrl: undefined,
        userRole: []
      },
      addManagerRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, message: '请输入正确的邮箱', trigger: 'blur' },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' },],
        avatarUrl: [{ required: true, message: '请上传头像', trigger: 'blur' },],
      },
      editManagerRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, message: '请输入正确的邮箱', trigger: 'blur' },
        ],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' },],
        avatarUrl: [{ required: true, message: '请上传头像', trigger: 'change' },],
      },
      userList: [], // 用户列表
      managerList: [], // 管理员列表
      managerSelectList: [], // 管理员下拉框数据
      roleEnum,
      group: []
    }
  },
  created() {
    this.isSuperAdministrator = this.$store.getters.userRole == 4
    this.getManagerSelectList()
    this.getAllUserGroup()
    this.getStorageParams()
    this.getUserList()
    this.getManagerList()
  },
  activated() {
    this.getUserList()
    this.getManagerList()
  },
  methods: {
    getAllUserGroup() {
      API.getAllUserGroup().then(res => {
        this.group = res.data
      })
    },
    changeGroup(value, row) {
      API.EditUserGroup({ userId: row.userId, userGroup: value }).then(() => {
        this.$message.success('修改用户分组成功')
        this.getUserList()
      })
    },
    userRegisterTimeSort({ order, prop }) {
      if (prop === "registerDate") {
        switch (order) {
          case 'ascending':
            this.listParams.sortType = 'asc'
            break
          case 'descending':
            this.listParams.sortType = 'desc'
            break
          case null:
            this.listParams.sortType = undefined
            break
        }
        this.resetPage()
      }
    },

    handleTimeChange(time) {
      this.registerDate = time
      if (this.registerDate && this.registerDate.length === 2) {
        this.listParams.registerDateStart = new Date(this.registerDate[0]).getTime()
        this.listParams.registerDateEnd = new Date(this.registerDate[1]).getTime()
      } else {
        this.listParams.registerDateStart = undefined
        this.listParams.registerDateEnd = undefined
      }
      this.getUserList()
    },

    clear() {
      this.filterValue = ''
      this.managerFilterValue = ''
      this.listParams.fullName = undefined
      this.listParams.userId = undefined
      this.listParams.userId = undefined
      this.resetPage()
    },

    getUserList() {
      const params = this.listParams
      params.fullName = undefined
      params.userId = undefined
      params.email = undefined
      if (this.filterValue) {
        switch (+this.filterType) {
          case 1:
            params.fullName = this.filterValue.trim()
            break
          case 2:
            params.userId = this.filterValue.trim()
            break
          case 3:
            params.email = this.filterValue.trim()
            break
        }
      }
      if(this.tabName === 'first') this.$store.commit('setState', { key: 'userGetListParams', value: {...params, tabName: this.tabName }})
      API.getUserList(params).then(result => {
        const list = result.data.list || []
        list.forEach(item => {
          item.isAuthentication = +item.isAuthentication === 1 ? '是' : '否'
          item.registerDate = dateFormat(item.registerDate)
        });
        this.userList = list
        this.total = result.data.total
      })
    },
    getManagerList() {
      if (!this.isSuperAdministrator) return
      const params = { ...this.managerListParams }
      if (this.managerFilterValue) {
        switch (+this.managerfilterType) {
          case 1:
            params.fullName = this.managerFilterValue.trim()
            break
          case 2:
            params.userId = this.managerFilterValue.trim()
            break
          case 3:
            params.email = this.managerFilterValue.trim()
            break
        }
      }
      if(this.tabName === 'second') this.$store.commit('setState', { key: 'userGetListParams', value: {...params, tabName: this.tabName }})
      API.getUserList(params).then(result => {
        const list = result.data && result.data.list ? result.data.list : []
        list.map(item => {
          const userRole = item.userRole.split(',')
          item.userRoleName = ''
          try {
            userRole.forEach(id => {
              item.userRoleName += ' ' + (roleEnum.find(role => +role.id === +id) ? roleEnum.find(role => +role.id === +id).name : '-')
            })
          } catch (error) {
            console.error(error)
          }
        })
        this.$set(this, 'managerList', list)
        this.managerTotal =  result.data && result.data.total ? result.data.total : 0
      })
    },
    getManagerSelectList() {
      API.getManagerSelectList({ roleList: [10] }).then(result => {
        this.managerSelectList = result.data
      })
    },
    resetPage() {
      this.listParams.pageNumber = 1
      this.getUserList()
    },
    sizeChange(size) {
      this.listParams.pageSize = size
      this.getUserList()
    },
    pageChange(page) {
      this.listParams.pageNumber = page
      this.getUserList()
    },
    managerSizeChange(size) {
      this.managerListParams.pageSize = size
      this.getManagerList()
    },
    managerPageChange(page) {
      this.managerListParams.pageNumber = page
      this.getManagerList()
    },
    managerChange(userId, userManager) {
      API.setUserManager({
        userId,
        userManager
      })
    },
    clickAddManager() {
      this.addManagerVisible = true
      this.$nextTick(() => this.$refs.addManagerForm.resetFields())
    },
    addManager() {
      this.$refs.addManagerForm.validate(valid => {
        if (!valid) return
        const params = { ...this.addManagerForm }
        params.password = encrypt(params.password)
        params.userRole = params.userRole.join(',')
        API.addManager(params).then(({ code, message }) => {
          if (code !== 10000) return this.$message.error(message)
          this.addManagerVisible = false
          this.$message.success('成功')
          this.getManagerList()
        })
      })
    },
    editManager() {
      this.$refs.editManagerForm.validate(valid => {
        if (!valid) return
        const params = this.editManagerForm
        params.userRole = params.userRole.join(',')
        API.editManager(params).then(({ code, message }) => {
          if (code !== 10000) return this.$message.error(message)
          this.editManagerVisible = false
          this.$message.success('成功')
          this.getManagerList()
        })
      })
    },
    resetManagerPage() {
      this.managerListParams.pageNumber = 1
      this.getManagerList()
    },
    clickEditManager(row) {
      let userRole = row.userRole.split(',')
      userRole.forEach((item, index) => {
        userRole[index] = parseInt(item)
      })
      this.editManagerForm = {
        userId: row.userId,
        email: row.email,
        fullName: row.fullName,
        avatarUrl: row.avatarUrl,
        userRole
      }
      this.editManagerVisible = true
    },
    // 上传图片 - 确认上传
    uploadImage(file, isEdit) {
      if (file.size > 1024 * 1024) return this.$message.error('图片大小不能超过1M')
      API.signValue({ directory: 'test/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'test/')
        formData.append('signValue', data)
        formData.append('fileList', file.raw)
        API.uploadFile(formData).then(result => {
          if (isEdit) {
            this.$refs.editManagerForm.clearValidate('avatarUrl')
            this.$set(this.editManagerForm, 'avatarUrl', result.data)
          } else {
            this.$refs.addManagerForm.clearValidate('avatarUrl')
            this.$set(this.addManagerForm, 'avatarUrl', result.data)
          }
        })
      })
    },
    deletManager(id) {
      this.$confirm('确认删除？').then(() => {
        API.deletManager(id).then(({ code, message }) => {
          if (code !== 10000) return this.$message.error(message)
          this.$message.success('成功')
          this.getManagerList()
        })
      })
    },
    exportData() {
      let form = {
        isAuthentication: this.listParams.isAuthentication,
        registerDateStart: this.listParams.registerDateStart,
        registerDateEnd: this.listParams.registerDateEnd,
        sortType: this.listParams.sortType,
        userRole: this.listParams.userRole
      }
      if (this.filterValue) {
        switch (+this.filterType) {
          case 1:
            form.fullName = this.filterValue
            break
          case 2:
            form.userId = this.filterValue
            break
          case 3:
            form.email = this.filterValue
            break
        }
      }
      let exportForm = {
        fileType: 2,
        taskType: 7,
        condition: JSON.stringify(form)
      }
      API.importExportFile(exportForm).then(res => {
        if (res.code === 10000) {
          this.$message.success('用户数据导出成功,请前往导入导出中心查看进度')
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getStorageParams() {
      let tabName, other
      if (this.$store.state.userGetListParams.tabName) {
        tabName = this.$store.state.userGetListParams.tabName
        other = this.$store.state.userGetListParams
      } else {
        tabName = this.tabName
        other = this.tabName === 'first' ? this.listParams : this.managerListParams
      }
      if(tabName === 'first') {
        if(other.fullName) {
          this.filterType = 1
          this.filterValue = other.fullName
        }
        if(other.userId) {
          this.filterType = 2
          this.filterValue = other.userId
        }
        if(other.email) {
          this.filterType = 3
          this.filterValue = other.email
        }
        this.listParams = other
      } else {
        if(other.fullName) {
          this.managerfilterType = 1
          this.managerFilterValue = other.fullName
        }
        if(other.userId) {
          this.managerfilterType = 2
          this.managerFilterValue = other.userId
        }
        if(other.email) {
          this.managerfilterType = 3
          this.managerFilterValue = other.email
        }
        this.managerListParams = other
      }
    },
    jumpLogin(row) {
      console.log(`${process.env.VUE_APP_KAKACLO_URL}/login?userId=${row.userId}&token=${getToken()}`)
      window.open(`${process.env.VUE_APP_KAKACLO_URL}/login?userId=${row.userId}&token=${getToken()}`);
    },

  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: white;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
</style>>
